module.exports = __webpack_public_path__ + "static/media/bac-bumper_selected.9568f22d.svg";